import { round } from 'lodash';
import { BridgeChartRow } from '../types';
import { BRIDGE_FOCUSED_NAV_THRESHOLD } from './constants';

const shouldUseBridgeZoom = (startingNav: number, endingNav: number) =>
  Math.max(Math.abs(startingNav), Math.abs(endingNav)) >
  BRIDGE_FOCUSED_NAV_THRESHOLD;

export const getMaxColumnTop = (chartRows: Array<BridgeChartRow>) =>
  Math.max(0, ...chartRows.map((row) => round(row.base + row.value, 2)));

const getTotalNavFromChartRows = (chartRows: Array<BridgeChartRow>) => {
  const startRow = chartRows.find((row) => row.key === 'startingNav');
  const endRow = chartRows.find((row) => row.key === 'endingNav');

  return {
    startingNav: startRow?.displayValue ?? 0,
    endingNav: endRow?.displayValue ?? 0,
  };
};

export const shouldUseBridgeFocusedAxis = (
  chartRows: Array<BridgeChartRow>,
) => {
  const { startingNav, endingNav } = getTotalNavFromChartRows(chartRows);

  return shouldUseBridgeZoom(startingNav, endingNav);
};

export const getMiddleBridgeExtents = (middleRows: Array<BridgeChartRow>) => {
  const stackTops = middleRows.map((row) => round(row.base + row.value, 2));
  const stackBottoms = middleRows.map((row) => row.base);

  return {
    bridgeMax: Math.max(0, ...stackTops),
    bridgeMin: stackBottoms.length > 0 ? Math.min(...stackBottoms) : 0,
    maxMiddleDelta:
      middleRows.length > 0
        ? Math.max(...middleRows.map((row) => Math.abs(row.displayValue)), 0)
        : 0,
  };
};
